module.exports = __webpack_public_path__ + "static/media/mainloader_ilia_new.47d3a3b9.gif";